<template>
  <SalesRepresentativeDashboard v-if="canAccessSalesDashboard" />
  <template v-else>
  <index-loader></index-loader>
  <layouts-header></layouts-header>
  <layouts-sidebar></layouts-sidebar>

  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <div class="content">
      <div class="row">
        <div class="col-md-12">
          <dashboard-header :title="title" />
          <div class="row">
            <div class="col-md-6 d-flex">
              <div class="card flex-fill">
                <div class="card-body p-0">
                  <div class="statistic-header px-2 py-3 p-md-3 mb-0 justify-content-start justify-content-md-between">
                    <div class="col-12 col-md-5 px-2 mb-2 mb-md-0">
                      <div class="form-wrap icon-form mb-0">
                        <span class="form-icon">
                          <i class="ti ti-search"></i>
                        </span>
                        <input type="text" class="form-control" placeholder="Search" v-model="searchQuery" />
                      </div>
                    </div>
                    <div class="col-md-5 px-2 flex-grow-1 flex-md-grow-0">
                      <select class="form-select" v-model="selectedOption">
                        <option v-for="option in searchOptions" :key="option.value" :value="option.value">
                          {{ option.text }}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-2 px-2 pe-0">
                      <button type="submit" @click="onSearch" class="btn btn-primary p-2">
                        <i class="ti ti-search"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 d-flex">
              <div class="card flex-fill" style="position: relative;">
                <div class="section-loader-overlay" v-if="isSearchLoading">
                  <span class="loader"></span>
                </div>
                <div class="card-body p-0">
                  <div class="statistic-header p-3 mb-3 border-bottom">
                    <div class="col-6">
                      <h4 class="mb-0">
                        <i class="ion-search me-2"></i> Last search
                      </h4>
                    </div>
                    <div class="col-6 text-end">
                    </div>
                  </div>
                  <!-- :onScroll="onScroll" -->
                  <deals-dashboard-table :onScroll="onScroll" :searchResults="searchResults"></deals-dashboard-table>
                </div>
              </div>
            </div>
            <div class="col-md-6 d-flex">
              <div class="card flex-fill" style="position: relative;">
                <div class="pipeline-loader-overlay" v-if="isPipelineLoading">
                  <span class="loader"></span>
                </div>
                <div class="card-body p-0 pb-3">
                  <div class="statistic-header p-3 border-bottom mb-3">
                    <div class="col-lg-4 col-md-4 col-12">
                      <h4 class="mb-0">
                        <!-- <router-link to="/crm/meter-opportunities-list"><i class="ti ti-chart-arcs me-1"></i> -->
                          Pipeline
                        <!-- </router-link> -->
                      </h4>
                    </div>
                    <div class="col-lg-8 col-md-8 col-12 d-flex justify-content-end align-items-center">
                      <ul>
                        <li class="days-filters-row days-filters-list">
                          <div id="toggle-filter" class="toggle-filter w-auto">
                            <span :class="{ active: isActive === 'today' }" @click="toggleFilter('today')">
                              Today
                            </span>
                            <span :class="{ active: isActive === 'all' }" @click="toggleFilter('all')">
                              All
                            </span>
                            <span :class="{ active: isActive === '365' }" @click="toggleFilter('365')">
                              365 (Days)
                            </span>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <deals-dashboard-table :pipeLineData="pipelineOppData" :overDuelength="total_opp"></deals-dashboard-table>
                </div>
              </div>
            </div>
            <div class="col-md-6 d-flex" v-if="user?.permissions?.includes('Meter Opportunities') && user?.permissions?.includes('Dashboard Opportunity')">
              <div class="card flex-fill" style="position: relative;">
                <div class="section-loader-overlay" v-if="isOppLoading">
                  <span class="loader"></span>
                </div>
                <div class="card-body p-0 pb-3">
                  <div class="statistic-header p-3 border-bottom mb-3">
                    <div class="col-6">
                      <h4 class="mb-0">
                        <router-link to="/crm/meter-opportunities-list"><i class="ti ti-chart-arcs me-1"></i>
                          Overdue Meter Opportunities
                        </router-link>
                      </h4>
                    </div>
                    <div class="col-6 text-end">
                      <p><strong class="me-1" style="color: #E41F07;">Overdue: </strong><strong>{{ total_opp }}</strong></p>
                    </div>
                  </div>
                  <deals-dashboard-table :onScroll="onScroll" :overDueOpportunities="overDueOpportunities"></deals-dashboard-table>
                </div>
              </div>
            </div>
            <div class="col-md-6 d-flex" v-if="user?.permissions?.includes('Organisations') && user?.permissions?.includes('Dashboard Organisation')">
              <div class="card flex-fill" style="position: relative;">
                <div class="section-loader-overlay" v-if="isOrgLoading">
                  <span class="loader"></span>
                </div>
                <div class="card-body p-0">
                  <div class="statistic-header p-3 mb-0 border-bottom">
                    <div class="col-6">
                      <h4 class="mb-0">
                        <router-link to="/crm/organisation-list">
                          <i class="ti ti-building-community me-1"></i> Organisations
                        </router-link>
                      </h4>
                    </div>
                    <div class="col-6 text-end">
                      <router-link :to="{ path: '/crm/create-organisation', query: { add: 'dashboard' } }"
                        class="btn btn-primary p-1">
                        <i class="ti ti-plus"></i>
                      </router-link>
                    </div>
                  </div>
                  <deals-dashboard-table :onScroll="onScroll" :organisations="organisations"></deals-dashboard-table>
                </div>
              </div>
            </div>
            <div class="col-md-6 d-flex" v-if="user?.permissions?.includes('Reports') && user?.permissions?.includes('Dashboard Reports & Charts')">
              <div class="card flex-fill" style="position: relative;">
                <div class="section-loader-overlay" v-if="isReportLoading">
                  <span class="loader"></span>
                </div>
                <div class="card-body p-0">
                  <div class="statistic-header p-3 mb-0 border-bottom">
                    <div class="col-6">
                      <h4 class="mb-0">
                        <router-link to="/crm/reports-list">
                          <i class="ti-bar-chart me-1"></i> Reports & Charts
                        </router-link>
                      </h4>
                    </div>
                    <div class="col-6 text-end">
                      <!-- <router-link class="btn btn-primary p-1" to="/crm/create-organisation">
                      <i class="ti ti-plus"></i>
                    </router-link> -->
                    </div>
                  </div>
                  <deals-dashboard-table :onScroll="onScroll" :userReports="userReports"></deals-dashboard-table>
                </div>
              </div>
            </div>
            <div class="col-md-6 d-flex"
              v-if="user?.permissions?.includes('Activities') && user?.permissions?.includes('Dashboard Activities')">
              <div class="card flex-fill" style="position: relative;">
                <div class="section-loader-overlay" v-if="isActivityLoading">
                  <span class="loader"></span>
                </div>
                <div class="card-body p-0 pb-3">
                  <div class="statistic-header p-3 mb-3 border-bottom">
                    <div class="col-6">
                      <h4 class="mb-0">
                        <router-link to="/crm/organisation-list">
                          <i class="ti ti-bounce-right me-1"></i> Activities
                        </router-link>
                      </h4>
                    </div>
                    <div class="col-6 text-end">
                      <router-link class="btn btn-primary p-1" to="/crm/create-activity">
                        <i class="ti ti-plus"></i>
                      </router-link>
                    </div>
                  </div>
                  <deals-dashboard-table :onScroll="onScroll" :userActivities="userActivities"></deals-dashboard-table>
                </div>
              </div>
            </div>
            <div class="col-md-12 d-flex"
              v-if="user?.permissions?.includes('Contracts') && user?.permissions?.includes('Dashboard Contracts')">
              <div class="card flex-fill" style="position: relative;">
                <div class="section-loader-overlay" v-if="isContractLoading">
                  <span class="loader"></span>
                </div>
                <div class="card-body p-0 pb-3">
                  <div class="statistic-header p-3 mb-3 border-bottom">
                    <div class="col-6">
                      <h4 class="mb-0">
                        <router-link to="/crm/contracts-list">
                          <i class="ti ti-bounce-right me-1"></i> Contracts
                        </router-link>
                      </h4>
                    </div>
                    <div class="col-6 text-end">
                      <router-link class="btn btn-primary p-1" to="/crm/create-contract">
                        <i class="ti ti-plus"></i>
                      </router-link>
                    </div>
                  </div>
                  <deals-dashboard-table :onScroll="onScroll" :userContracts="userContracts"></deals-dashboard-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Page Wrapper -->
  </template>
</template>

<script>
import SalesRepresentativeDashboard from '@/views/pages/dashboard/sales-representative-dashboard/sales-representative-dashboard.vue';
import {
  ref
} from "vue";
import {
  onMounted,
  computed
} from "vue";
import {
  useStore, mapGetters
} from "vuex";
import {
  useRouter,
  useRoute
} from "vue-router";
import { message } from "ant-design-vue";
import { canAccessSalesDashboard as hasSalesDashboardPermission } from '@/util';
export default {
  components: {
    SalesRepresentativeDashboard,
  },
  data() {
    return {
      title: "Dashboard",
    };
  },
  computed: {
    ...mapGetters('auth', ['user']),
    canAccessSalesDashboard() {
      return hasSalesDashboardPermission(this.user);
    },
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const isActive = ref( localStorage.getItem('dashboard365') || "today");

    const searchOptions = ref([{
      value: 'organization',
      text: 'Organisation'
    }, {
      value: 'person',
      text: 'Person'
    }, {
      value: 'telephone',
      text: 'Telephone'
    }, {
      value: 'mpr',
      text: 'MPR NO.'
    },
    {
      value: 'mpan_top',
      text: 'MPAN Top'
    },
    {
      value: 'mpan_bottom',
      text: 'MPAN Bottom'
    },
    {
      value: 'postcode',
      text: 'Postcode'
    }]);

    const organisations = ref([]);
    const overDueOpportunities = ref([]);
    const searchResults = ref([]);
    const userActivities = ref([]);
    const userContracts = ref([])
    const userReports = ref([]);
    const pipelineOppData = ref({});

    const total = ref(false);
    const current_page = ref(1);
    const current_opp_page = ref(1);
    const total_opp = ref();
    const current_report_page = ref(1);
    const current_search_page = ref(1);
    const current_act_page = ref(1);
    const current_cont_page = ref(1);
    const total_report = ref();
    const total_act = ref();
    const total_cont = ref();
    const total_search = ref(1);
    const isFetching = ref(false);
    const isPipelineLoading = ref(false);
    const isOrgLoading = ref(false);
    const isOppLoading = ref(false);
    const isActivityLoading = ref(false);
    const isReportLoading = ref(false);
    const isContractLoading = ref(false);
    const isSearchLoading = ref(false);

    const searchQuery = ref('');
    const selectedOption = ref(searchOptions.value[0].value);

    const onSearch = async () => {
      isFetching.value = true
      searchResults.value = []
      current_search_page.value = 1;
      total_search.value = 1;
      if (searchQuery.value === '') {
        message.error('Please enter a text to search for');
        return;
      }
      fetchData(searchQuery.value, selectedOption.value)
    }

    const fetchData = async (searchQuery, selectedOption) => {
      try {
        let resData;
        if (current_search_page.value === 1) {
         const resData = await store.dispatch('dashboard/getDashboardData', {
            search: searchQuery,
            type: selectedOption,
            page: current_search_page.value,
            pageSize: 10
          })
          searchResults.value = resData.data;
          current_search_page.value = resData.data?.current_page + 1;
          total_search.value = resData.data?.total;
          return;
        }
        let count = searchResults.value.data.length;
        if (count >= 10 && total_search.value > count) {
          if (isFetching.value) return;
          isFetching.value = true;
          isSearchLoading.value = true;
          current_search_page.value = Math.ceil(count / 10) + 1;
          const params = {
            search: searchQuery,
            type: selectedOption,
            page: current_search_page.value,
            pageSize: 10,
            skipGlobalLoader: true
          };
          resData = await store.dispatch("dashboard/getDashboardData", params);
          const key = 'search'
          appendDynamicData(searchResults.value, resData.data.data, key);
          current_search_page.value = resData.data?.current_page + 1;
          return;
        }

      } catch (error) {
        console.error("Error fetching search data:", error);
      }
      finally {
        isFetching.value = false;
        isSearchLoading.value = false;
      }
    };
    const appendDynamicData = (existingData, dynamicData, key) => {
      const combinedOutput = existingData.data.slice(); // Clone the existing output array
      dynamicData.forEach((item) => {
        combinedOutput.push(item);
      });
      if(key === 'opp'){
        overDueOpportunities.value.data = combinedOutput;
      } else if(key==='report') {
        userReports.value.data = combinedOutput;
      } else if (key === 'search'){
        searchResults.value.data = combinedOutput;
      } else if (key === 'activity'){
        userActivities.value.data = combinedOutput;
      } else if(key === 'contracts'){
        userContracts.value.data = combinedOutput
      } else {
        organisations.value.data = combinedOutput;
      }
      return { data: combinedOutput };
    };

    const fetchOrgData = async () => {
      try {
        let resData;
        if (current_page.value === 1) {
          resData = await store.dispatch('dashboard/getOrgData', {
            page: current_page.value,
            pageSize: 15
          })
          organisations.value = resData.data.organizations;
          current_page.value = resData.data.organizations?.current_page + 1;
          total.value = resData.data.organizations?.total;
          return;
        }
        let count = organisations.value.data.length;
        if (count >= 15 && total.value > count) {
          if (isFetching.value) return;
          isFetching.value = true;
          isOrgLoading.value = true;
          current_page.value = Math.ceil(count / 15) + 1;
          const params = {
            page: current_page.value,
            pageSize: 15,
            skipGlobalLoader: true
          };
          resData = await store.dispatch("dashboard/getOrgData", params);
          appendDynamicData(organisations.value, resData.data.organizations.data);
          current_page.value = resData.data?.current_page + 1;
          return;
        }

      } catch (error) {
        console.error("Error fetching organization data:", error);
      }
      finally {
        isFetching.value = false;
        isOrgLoading.value = false;
      }
    };

    const fetchOppData = async () => {
      try {
        let resData;
        if (current_opp_page.value === 1) {
          resData = await store.dispatch('dashboard/getOverDueOpp', {
            page: current_opp_page.value,
            pageSize: 8
          })
          overDueOpportunities.value = resData.data.overdue_opportunities;
          current_opp_page.value = resData.data.overdue_opportunities?.current_page + 1;
          total_opp.value = resData.data.overdue_opportunities?.total;
          return;
        }
        let count = overDueOpportunities.value.data.length;
        if (count >= 8 && total_opp.value > count) {
          if (isFetching.value) return;
          isFetching.value = true;
          isOppLoading.value = true;
          current_opp_page.value = Math.ceil(count / 8) + 1;
          const params = {
            page: current_opp_page.value,
            pageSize: 8,
            skipGlobalLoader: true
          };
          resData = await store.dispatch("dashboard/getOverDueOpp", params);
          const key = 'opp'
          appendDynamicData(overDueOpportunities.value, resData.data.overdue_opportunities.data, key);
          current_opp_page.value = resData.data?.current_page + 1;
          return;
        }

      } catch (error) {
        console.error("Error fetching opportunity data:", error);
      }
      finally {
        isFetching.value = false;
        isOppLoading.value = false;
      }
    };
    const fetchActivities = async () => {
      try {
        let resData;
        if (current_act_page.value === 1) {
          resData = await store.dispatch('dashboard/getActivities', {
            page: current_act_page.value,
            pageSize: 8
          })
          userActivities.value = resData.data.activities;
          current_act_page.value = resData.data.activities?.current_page + 1;
          total_act.value = resData.data.activities?.total;
          return;
        }
        let count = userActivities.value.data.length;
        if (count >= 8 && total_act.value > count) {
          if (isFetching.value) return;
          isFetching.value = true;
          isActivityLoading.value = true;
          current_act_page.value = Math.ceil(count / 8) + 1;
          const params = {
            page: current_act_page.value,
            pageSize: 8,
            skipGlobalLoader: true
          };
          resData = await store.dispatch("dashboard/getActivities", params);
          const key = 'activity'
          appendDynamicData(userActivities.value, resData.data.activities.data, key);
          current_act_page.value = resData.data?.current_page + 1;
          return;
        }

      } catch (error) {
        console.error("Error fetching activities data:", error);
      }
      finally {
        isFetching.value = false;
        isActivityLoading.value = false;
      }
    };
    const fetchReportData = async () => {

      try {
        let resData;
        if (current_report_page.value === 1) {
          resData = await store.dispatch('dashboard/getReportsData', {
            page: current_report_page.value,
            pageSize: 10
          })
          userReports.value = resData.data.reports;
          current_report_page.value = resData.data.reports?.current_page + 1;
          total_report.value = resData.data.reports?.total;
          return;
        }
        let count = userReports.value.data.length;
        if (count >= 10 && total_report.value > count) {
          if (isFetching.value) return;
          isFetching.value = true;
          isReportLoading.value = true;
          current_report_page.value = Math.ceil(count / 10) + 1;
          const params = {
            page: current_report_page.value,
            pageSize: 10,
            skipGlobalLoader: true
          };
          resData = await store.dispatch("dashboard/getReportsData", params);
          const key = 'report'
          appendDynamicData(userReports.value, resData.data.reports.data, key);
          current_report_page.value = resData.data?.current_page + 1;
          return;
        }

      } catch (error) {
        console.error("Error fetching report data:", error);
      }
      finally {
        isFetching.value = false;
        isReportLoading.value = false;
      }

    };

    const fetchContracts = async () => {
      try {
        let resData;
        if (current_cont_page.value === 1) {
          resData = await store.dispatch('dashboard/getContracts', {
            page: current_cont_page.value,
            pageSize: 8
          })
          userContracts.value = resData.data.contracts;
          current_cont_page.value = resData.data.contracts?.current_page + 1;
          total_cont.value = resData.data.contracts?.total;
          return;
        }
        let count = userContracts.value.data.length;
        if (count >= 8 && total_cont.value > count) {
          if (isFetching.value) return;
          isFetching.value = true;
          isContractLoading.value = true;
          current_cont_page.value = Math.ceil(count / 8) + 1;
          const params = {
            page: current_cont_page.value,
            pageSize: 8,
            skipGlobalLoader: true
          };
          resData = await store.dispatch("dashboard/getContracts", params);
          const key = 'contracts'
          appendDynamicData(userContracts.value, resData.data.contracts.data, key);
          current_cont_page.value = resData.data?.current_page + 1;
          return;
        }

      } catch (error) {
        console.error("Error fetching contract data:", error);
      }
      finally {
        isFetching.value = false;
        isContractLoading.value = false;
      }
    };

    const onScroll = (event) => {
      const element = event.target;
      if (element.scrollTop + element.clientHeight >= element.scrollHeight - 3 && !isFetching.value) {
        if(element.id === 'overDueOpportunities'){
          fetchOppData();
        } else if(element.id === 'orgSection'){
          fetchOrgData();
        } else if(element.id === 'userReports'){
          fetchReportData();
        } else if(element.id === 'searchSection') {
          fetchData(searchQuery.value, selectedOption.value);
        } else if(element.id === 'userActivities') {
          fetchActivities();
        } else if(element.id === 'userContracts'){
          fetchContracts();
        }
      }
    };
    const fetchPiplineOppCount = async (skipGlobalLoader = false) =>{
      try {
        // Only show local loader if we're skipping the global loader (filter changes)
        if (skipGlobalLoader) {
          isPipelineLoading.value = true;
        }
        const resData = await store.dispatch('dashboard/getOppCount', { 
          params: isActive.value,
          skipGlobalLoader: skipGlobalLoader 
        });
        pipelineOppData.value = resData;
      } catch (error) {
        console.error("Error fetching pipeline data:", error);
      } finally {
        if (skipGlobalLoader) {
          isPipelineLoading.value = false;
        }
      }
    }
    const toggleFilter = (value) => {
      isActive.value = value;
      localStorage.setItem('dashboard365', value)
      fetchPiplineOppCount(true); // Use local loader when changing filters
    };
    onMounted(async () => {
      const user = store.getters['auth/user'];
      if (hasSalesDashboardPermission(user)) {
        return;
      }
      await fetchActivities();
      await fetchOrgData();
      await fetchOppData();
      await fetchReportData();
      await fetchContracts();
      await fetchPiplineOppCount(false); // Use global loader on initial load
    });

    return {
      userReports,
      onSearch,
      userActivities,
      userContracts,
      searchQuery,
      current_act_page,
      current_cont_page,
      total_act,
      total_cont,
      selectedOption,
      organisations,
      overDueOpportunities,
      searchResults,
      current_search_page,
      fetchActivities,
      total_search,
      searchOptions,
      fetchData,
      fetchOrgData,
      pipelineOppData,
      fetchOppData,
      fetchReportData,
      fetchContracts,
      onScroll,
      total,
      current_page,
      appendDynamicData,
      isFetching,
      current_opp_page,
      total_opp,
      current_report_page,
      total_report,
      isActive,
      toggleFilter,
      isPipelineLoading,
      isOrgLoading,
      isOppLoading,
      isActivityLoading,
      isReportLoading,
      isContractLoading,
      isSearchLoading
    };
  },
};
</script>
<style scoped lang="scss">
.pipeline-loader-overlay,
.section-loader-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  border-radius: 0.375rem;
  
  .loader {
    width: 64px;
    height: 64px;
    position: relative;
    animation: rotate 1.5s ease-in infinite alternate;
    margin-top: 80px;
    margin-left: 90px;
    
    &::before {
      content: "";
      position: absolute;
      left: 0;
      bottom: 0;
      color: #3C2371;
      background: currentColor;
      width: 64px;
      height: 32px;
      border-radius: 0 0 50px 50px;
    }
    
    &::after {
      content: "";
      position: absolute;
      left: 50%;
      top: 10%;
      background: #00918E;
      width: 8px;
      height: 64px;
      animation: rotate 1.2s linear infinite alternate-reverse;
    }
  }
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}
</style>
